import { ToastViewport } from "@/components/layout/ToastViewport";
import { useHashRoute } from "@/lib/router";
import { Activity } from "@/screens/Activity";
import { AgentActivity } from "@/screens/AgentActivity";
import { AgentChatLog } from "@/screens/AgentChatLog";
import { AgentTask } from "@/screens/AgentTask";
import { Chat } from "@/screens/Chat";
import { Discover } from "@/screens/Discover";
import { Home } from "@/screens/Home";
import { Onboard } from "@/screens/Onboard";
import { OrderConfirmation } from "@/screens/OrderConfirmation";
import { Orders } from "@/screens/Orders";
import { Products } from "@/screens/Products";
import { ProviderDashboard } from "@/screens/ProviderDashboard";
import { ProviderExplore } from "@/screens/ProviderExplore";
import { ProviderProfile } from "@/screens/ProviderProfile";
import { Results } from "@/screens/Results";
import { Reset } from "@/screens/Reset";
import { Welcome } from "@/screens/Welcome";
import { You } from "@/screens/You";
import { AppProvider } from "@/state/AppContext";

function Router() {
  const [route, navigate, onboardRole] = useHashRoute();

  switch (route) {
    case "home":
      return <Home navigate={navigate} />;
    case "onboard":
      return <Onboard navigate={navigate} initialRole={onboardRole ?? "customer"} />;
    case "reset":
      return <Reset navigate={navigate} />;
    case "discover":
      return <Discover navigate={navigate} />;
    case "you":
      return <You navigate={navigate} />;
    case "chat":
      return <Chat navigate={navigate} />;
    case "products":
      return <Products navigate={navigate} />;
    case "provider-orders":
      return <Orders navigate={navigate} />;
    case "provider-products":
      return <Products navigate={navigate} />;
    case "provider-chat":
      return <Chat navigate={navigate} />;
    case "provider-settings":
      return <ProviderProfile navigate={navigate} />;
    case "agent-task":
      return <AgentTask navigate={navigate} />;
    case "agent-activity":
      return <AgentActivity navigate={navigate} />;
    case "agent-chat-log":
      return <AgentChatLog navigate={navigate} />;
    case "activity":
      return <Activity navigate={navigate} />;
    case "review":
      return <Results navigate={navigate} />;
    case "confirmed":
      return <OrderConfirmation navigate={navigate} />;
    case "provider":
      return <ProviderDashboard navigate={navigate} />;
    case "provider-explore":
      return <ProviderExplore navigate={navigate} />;
    case "provider-profile":
      return <ProviderProfile navigate={navigate} />;
    case "welcome":
    default:
      return <Welcome navigate={navigate} />;
  }
}

export function App() {
  return (
    <AppProvider>
      <Router />
      <ToastViewport />
    </AppProvider>
  );
}

export default App;
